import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import "./MethodSelection.scss";
import PWCascader from "../../common/PWCascader/PWCascader";
import { multiSourceCategories, removeDuplicateObjects } from "../../../helper";
import { useTranslation } from "react-i18next";
const MethodSelection = (props: any) => {
  const { t, i18n } = useTranslation();
  const {
    methods,
    onSelectMethod,
    setOpen,
    category,
    categoryPreference,
    categoryPreferences,
    setCategoryPreferences,
  } = props;
  const [selectedMethods, setSelectedMethods] = useState(methods);
  const [source, setSource] = useState({ type: "", subType: "" });
  const [subTypes, setSubTypes] = useState([]);
  const [showMethod, setShowMethod] = useState(false);
  const isMultiSources = (category: any) => {
    return true;
  };
  const onSelectEmissionSource = (e: any) => {
    console.log("e = {}", e);
    let preferences = categoryPreferences?.length
      ? categoryPreferences
      : JSON.parse(localStorage.getItem("categoryPreferences") || "");
    let key =
      localStorage.getItem("protocol") == "ghg" ? "ghgCategory" : "category";
    let categoryPreference = preferences.find(
      (eachPreference: any) => eachPreference[key] === category.id
    );
    if (categoryPreference) {
      categoryPreference.emissionSubType = e[0].subType
        ? e[0].subType
        : e[0].sub_type;
      categoryPreference.emissionType = e[0].type;
    }
    setCategoryPreferences([...preferences]);
    setSource({
      type: e[0].type,
      subType: e[0].subType ? e[0].subType : e[0].sub_type,
    });
    let selectedMethods = categoryPreference.methods.filter(
      (eachMethod: any) =>
        (!eachMethod.sub_type || eachMethod.sub_type === e[0].subType) &&
        eachMethod.type === e[0].type
    );
    setSelectedMethods(selectedMethods);
    if (selectedMethods?.length === 1) {
      onSelectMethod(selectedMethods[0].id);
    }
    setShowMethod(true);
  };
  // const setContent = () => {
  //   let subTypes: any = getInitOptionsFromDefault(selectedMethods);
  //   setSubTypes(subTypes);
  //   // getEmissionSourceData(category.id.toString()).then((res: any) => {
  //   //   let subTypes = res.data;
  //   //   subTypes = subTypes.map((each: any) => {
  //   //     let children = each.children.filter((each: any) => each.label);
  //   //     if (!children.length) {
  //   //       delete each.children;
  //   //     }
  //   //     return each;
  //   //   });
  //   //   setSubTypes(subTypes);
  //   //   //label,value type nested array
  //   // });
  // };
  const getInitOptionsFromDefault = (types: any = selectedMethods) => {
    let catTypesData = removeDuplicateObjects(types, "sub_type");
    let resMap: any = {};
    catTypesData.forEach((eachType: any) => {
      if (resMap[eachType.type]) {
        resMap[eachType.type].children.push({
          label: eachType.subTypeName
            ? eachType.subTypeName
            : eachType.sub_type_name,
          value: eachType.subType ? eachType.subType : eachType.sub_type,
        });
      } else {
        resMap[eachType.type] = {
          label: eachType.typeName ? eachType.typeName : eachType.type_name,
          value: eachType.type,
          children: [],
        };
        if (eachType.subType || eachType.sub_type) {
          resMap[eachType.type].children.push({
            label: eachType.subTypeName || eachType.sub_type_name,
            value: eachType.subType || eachType.sub_type,
          });
        }
      }
    });
    console.log("getInitOptionsFromDefault", Object.values(resMap));
    return Object.values(resMap);
  };
  console.log(
    "isMultiSources(category.id) && source?.type",
    isMultiSources(category) && source?.type
  );
  console.log("isMultiSources(category.id)", isMultiSources(category));

  return (
    <div className="w-45v h-55v pw-dialog-padding">
      <div className="flex flex-col justify-between w-full gap-3">
        <div className="flex flex-row justify-between w-full">
          <div className="text-2xl font-semibold">
            {t("Log emission against")}
          </div>
          <CloseIcon onClick={() => setOpen(false)} />
        </div>
        <div className="text-base">{t("File Upload Message")}</div>
      </div>

      {/* <Cascader
          options={subTypes}
          showCheckedStrategy={SHOW_CHILD}
          open={true}
          changeOnSelect
        /> */}
      <div className="text-sm font-semibold text-neutral-500 mb-4 mt-9">
        {`${category.code.toUpperCase()} ${category.name.toUpperCase()}`}
      </div>

      {categoryPreference.emissionSources?.length && (
        <div>
          <div>{t("Emission Source")} :</div>
          <div className="pw-multi-dropdown pw-method-dropdown">
            <PWCascader
              defaultOptions={getInitOptionsFromDefault}
              optionsData={subTypes}
              onSelectCascade={(e: any) => {
                onSelectEmissionSource(e);
              }}
              setContent={(e: any) => {
                //  setContent();
              }}
              setShowMethod={setShowMethod}
            />
          </div>
        </div>
      )}
      {showMethod && (
        <div
          className={`min-h-[1vh] ${
            ((isMultiSources(category) && source?.type) ||
              !isMultiSources(category)) &&
            selectedMethods?.length &&
            "border border-solid rounded-lg border-neutral-200"
          }`}
        >
          {((isMultiSources(category) && source?.type) ||
            !isMultiSources(category)) &&
            selectedMethods?.length &&
            selectedMethods.map((eachMethod: any, index: number) => (
              <div
                className={`flex flex-col border-b border-neutral-200 ${
                  index === selectedMethods?.length - 1 && "!border-b-0"
                }`}
              >
                {eachMethod.selected && (
                  <div
                    onClick={() => onSelectMethod(eachMethod.id)}
                    key={eachMethod.id}
                    className="p-6 flex flex-row pw-method-list justify-between border-solid border-neutral-200 cursor-pointer"
                  >
                    <div> {eachMethod.name}</div>
                    <ArrowForwardIcon className="pw-hover-display" />
                  </div>
                )}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default MethodSelection;
